export default __webpack_public_path__ + "static/media/Badal_Google_Technical_Support_Fundamentals.b29a1c9d.png";